module.exports = "<div ng-class=\"{\n  container: !$$setting.data.general.checkboxs.largeMode.model,\n  largeContainer: $$setting.data.general.checkboxs.largeMode.model\n}\"\n  class=\"page-view has-bottom-menu-2\">\n  <my-radio-menu my-menu=\"consultMenu\"\n    my-id=\"consult\">\n  </my-radio-menu>\n\n  <div class=\"line-separator\"></div>\n\n  <div ui-view>\n  </div>\n\n  <div class=\"bottom-menu\">\n    <div class=\"line-separator\"></div>\n    <my-radio-menu my-menu=\"consultMenu\"\n      my-id=\"consult\">\n    </my-radio-menu>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/routing/consult/templates/index.html
// module id = 1566
// module chunks = 0